import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AppDispatch, GetState, RootState } from '../store'
import { selectDMs } from './dms'

type DraftState = {
  messages: { [id: string]: string }
}

const initialState: DraftState = {
  messages: {}
}

const draftSlice = createSlice({
  name: 'draft',
  initialState,
  reducers: {
    setDraft: (
      state: DraftState,
      action: PayloadAction<{ id: string; message: string }>
    ) => {
      const { id, message } = action.payload
      state.messages[id] = message
    }
  }
})

const { setDraft } = draftSlice.actions

export const updateDraft = (message: string) => {
  return async (dispatch: AppDispatch, getState: GetState) => {
    const { selectedConvo } = selectDMs(getState())
    dispatch(setDraft({ id: selectedConvo, message }))
  }
}

export const selectDraft = (state: RootState) => state.draft

export default draftSlice.reducer
